module.exports = __webpack_public_path__ + "img/computer-alert.b524d8d0.svg";